import React, { RefObject, useEffect } from 'react';

export const useTopPositions = (
  refs: RefObject<HTMLElement>[],
  cssVarNames: string[],
): void => {
  const updatePositions = () => {
    refs.forEach((ref, index) => {
      if (ref && ref.current) {
        const rect = ref.current.getBoundingClientRect();
        const padding = window.getComputedStyle(ref.current).paddingTop;
        const paddingTop = padding ? parseInt(padding, 10) : 0;
        const topPosition = rect.top + paddingTop;
        document.documentElement.style.setProperty(`--${cssVarNames[index]}`, `${topPosition}px`);
        return;
      }
      
      document.documentElement.style.removeProperty(`--${cssVarNames[index]}`);

    });
  };

  useEffect(() => {
    updatePositions();
    window.addEventListener('resize', updatePositions);
    window.addEventListener('scroll', updatePositions);

    return () => {
      window.removeEventListener('resize', updatePositions);
      window.removeEventListener('scroll', updatePositions);
    };
  }, [refs, cssVarNames]);
};
